export default __webpack_public_path__ + "static/media/015.47df360f.jpg";